// mutations types

export const CLEAR_TOKEN = 'CLEAR_TOKEN' // 清空 auth token

export const SAVE_TOKEN = 'SAVE_TOKEN' // 保存 auth token

export const SAVE_CURRENT_CITY = 'SAVE_CURRENT_CITY'

export const SAVE_CITY_LIST = 'SAVE_CITY_LIST' // 热门城市列表

export const SAVE_QUERY = 'SAVE_QUERY'

export const SAVE_CITY_PICK = 'SAVE_CITY_PICK'

export const SAVE_FEED_LIST = 'SAVE_FEED_LIST'

export const SAVE_NAVIGATION = 'SAVE_NAVIGATION'

export const SET_IS_APP = 'SET_IS_APP'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js